<template>
    <div>
<el-dialog
      title="联系客服"
      :visible="visible"
      width="30%"
      @close="closeDia">
      <div class="chat1"> <i class="icon iconfont iconkefu1"></i> 客服热线: 大象搜"lusi"</div>
      <div class="chat2">周一至周五: 9:30-18:00</div>
    </el-dialog>

    </div>
</template>


<script>
export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        closeDia() {
            this.$emit('update:visible', false)
        },
    }
}
</script>

<style scoped lang="scss">


.chat1, .chat2 {
  text-align: center;
}
.chat1 {
  font-size: 22px;
  margin: 20px 0;
  i {
    font-size: 26px;
  }
}
.chat2 {
  padding-bottom: 20px;
}
</style>